/* eslint-disable react/jsx-no-target-blank */
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { getRequest } from '../../api/ApiService';
import { fetchTeamStatus } from '../../api/TeamDecisionsService';
import { fetchTracks } from '../../services/tracks-cache';
import { Loader } from "react-loaders";
import Auth from '../../routes/Auth';
import Teams from '../../api/Teams';
import EventEmitter from '../../services/event-emitter';
import { roleToUrl } from '../../services/utils';

import SmallCheckbox from '../../containers/assets/small-checkbox.png';
import SmallCheckboxActive from '../../containers/assets/small-checkbox-active.png';

import Image1 from '../../containers/assets/next-steps-1.png';
import Image2 from '../../containers/assets/next-steps-2.png';
import Image3 from '../../containers/assets/next-steps-3.png';
import Image4 from '../../containers/assets/next-steps-4.png';
import Image5 from '../../containers/assets/next-steps-4.png';

const Wrapper = styled.div`
  background: #f5f6f7;
  flex: 1;

  .loader {
    display: inline-block;
  }

  .loader .loader-inner div {
    border-color: #36507e;
  }
`;

const Container = styled.div`
  padding: 40px;
  width: 992px;
`;

const Text1 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
  text-transform: uppercase;
`;

const Text2 = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 24px;
`;

const Image = styled.div`
  position: absolute;
  top: -7.5px;
  right: 40px;

  img {
    height: 255px;
  }
`;

const BigGoal = styled.div`
  margin-top: 24px;
  border-radius: 8px;
  background: #fec665;
  padding: 56px 40px 40px 40px;
  position: relative;
  min-height: 240px;
  max-width: 912px;
`;

const BigGoalTitleNum = styled.div`
  width: 32px;
  height: 32px;
  background: #faf5eb;
  border-radius: 4px;
  border: 1px solid #eca427;

  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 18px;
  color: #eca427;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const BigGoalTitle = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;

  a:active, a:visited, a:link {
    color: rgba(0, 27, 59, 0.94);
  }

  a:hover {
    text-decoration: underline;
  }
`;

const BigGoalDescription = styled.div`
  margin-top: 4px;
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
  width: calc(100% - 472px);
`;

const CheckboxesRow = styled.div`
  margin-top: 27px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px 19px;
  width: calc(100% - 460px);
  flex-wrap: wrap;
`;

const Checkbox = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  flex-wrap: nowrap;

  a:active, a:visited, a:link {
    font-family: 'Mukta Vaani';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: rgba(0, 27, 59, 0.94);
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }
`;

const SmallGoals = styled.div`
  margin-top: 24px;

  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 24px;
`;

const SmallGoal = styled.div`
  width: 288px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #d5d9dd;
  padding: 16px 16px 48px;
  position: relative;

  ${p => p.isGreyed && `
    opacity: 0.6;
  `}

  img {
    position: absolute;
    right: 16px;
    bottom: 16px;
  }
`;

const SmallGoalTitleNum = styled.div`
  width: 32px;
  height: 32px;
  background: #faf5eb;
  border-radius: 4px;
  border: 1px solid #eca427;

  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 18px;
  color: #eca427;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const SmallGoalTitle = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;

  a:active, a:visited, a:link {
    font-family: 'Mukta Vaani';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: rgba(0, 27, 59, 0.94);
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }
`;

const SmallGoalDescription = styled.div`
  margin-top: 8px;
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 27, 59, 0.6);
`;

class NextStepsPage extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      isBusinessCaseVisited: false,
      isCustomerAnalysisVisited: false,
      isPriorRoundVisited: false,
      isGoalsSubmitted: false,
      isTriviaDone: false,
      userRole: '',
      pdSubmitted: false,
      pmSubmitted: false,
      opSubmitted: false,
      fnSubmitted: false,
      triviaCourseAvailable: 0
    };
    this.eventemitter = EventEmitter.getInstance();
  }

  componentDidMount() {
    const { currentRound, rounds } = this.props;

    const courseId = Number(Auth.getCourseId());
    const gameId = Number(Auth.getGameId());
    const userId = Number(Auth.getUserId());

    this.eventemitter.trigger('next-steps-visited');
    this.props.setMode('basic');

    // Per-role "Submitted" state used to come from a full journal scan
    // (find latest successful submit_*, look for newer same-role edits).
    // team-status already exposes the same signal in two fields per
    // role — submission_data.{pd,pm,op,fn}.date and .unaccepted — so
    // we run that fetch in parallel and skip the journal call.
    //
    // The three engagement-tracks reads go through fetchTracks (a
    // module-level promise cache), which means App.js's identical
    // current-round call and analytics-send's preflight check all
    // share one network round trip instead of three.
    Promise.all([
      fetchTracks({ gameId, courseId, userId, roundNumber: currentRound }),
      getRequest(`${process.env.REACT_APP_API_URL}v2/games/goaltargets/`),
      ...(currentRound === 1 ? [] : [
        fetchTracks({ gameId, courseId, userId, roundNumber: currentRound - 1 })
      ]),
      fetchTracks({ gameId, courseId, userId }),
      fetchTeamStatus(currentRound),
    ])
      .then((results) => {
        // Slot layout matches the downstream `res[N]` references below.
        // When currentRound === 1, the prior-round slot is omitted so
        // res[2] becomes the all-rounds response (used for both the
        // prior-round-visited check, which short-circuits to true, and
        // the all-rounds business-case check).
        const hasPrior = currentRound !== 1;
        const res = hasPrior
          ? [results[0], results[1], results[2], results[3]]
          : [results[0], results[1], results[2]];
        const statusData = hasPrior ? results[4] : results[3];
        const currentTeam = Teams.currentTeam();
        const teamId = Number(currentTeam.id);

        const round = rounds.find(i => i.number === currentRound);
        const roundId = round ? Number(round.id) : 0;
        const baseUrl = `${window.location.protocol}//${window.location.host}`;

        // Index map after dropping the journal slot:
        //   res[0] = current-round engagement tracks
        //   res[1] = goalsTargets
        //   res[2] = prior-round engagement tracks (only when currentRound > 1)
        //   res[2/3] = all-rounds engagement tracks
        // When currentRound === 1, prior-round tracks isn't fetched, so
        // res[2] is the all-rounds payload (used twice as a stand-in).
        const trackedPages = res[0].body;
        const goalsTargets = res[1].body;
        const triviaCourseAvailable = 0;
        const priorRoundTrackedPages = currentRound === 1 ? [] : res[2].body;

        const trackedPagesForAllRounds = currentRound === 1 ? res[2].body : res[3].body;

        const pages = trackedPages.results
          .filter(i => (
            i.page.indexOf(`${window.location.protocol}//${window.location.host}`) === 0
          ))
          .map(i => i.page.replace(`${window.location.protocol}//${window.location.host}/`, ''))
          .map(i => i.split('?')[0]);

        const pagesForAllRounds = trackedPagesForAllRounds.results
          .filter(i => (
            i.page.indexOf(`${window.location.protocol}//${window.location.host}`) === 0
          ))
          .map(i => i.page.replace(`${window.location.protocol}//${window.location.host}/`, ''))
          .map(i => i.split('?')[0]);
        const priorRoundPages = currentRound === 1 ? [] : priorRoundTrackedPages.results
          .filter(i => (
            Number(i.course) === courseId &&
            Number(i.game) === gameId &&
            Number(i.round_number) === currentRound - 1 &&
            Number(i.user) === userId &&
            i.page.indexOf(baseUrl) === 0
          ))
          .map(i => i.page.replace(`${baseUrl}/`, ''))
          .map(i => i.split('?')[0]);

        const isBusinessCaseVisited = (
          pagesForAllRounds.includes('analysis/bcase/executive-summary')
          && pagesForAllRounds.includes('analysis/bcase/opportunity-economy-industry')
          && pagesForAllRounds.includes('analysis/bcase/market')
          && pagesForAllRounds.includes('analysis/bcase/product')
          && pagesForAllRounds.includes('analysis/bcase/operations')
          && pagesForAllRounds.includes('analysis/bcase/investors')
        );
        const isCustomerAnalysisVisited = (
          pages.includes('ceo/analysis/market')
          || pages.includes('pd/analysis/market')
          || pages.includes('pm/analysis/market')
          || pages.includes('op/analysis/market')
          || pages.includes('fn/analysis/market')
        );
        const isPriorRoundVisited = currentRound === 1 ? true : (
          priorRoundPages.includes('analysis/team-reports/marketing-analysis/market-share-capture')
          && priorRoundPages.includes('analysis/team-reports/marketing-analysis/customer-survey')
          && priorRoundPages.includes('analysis/team-reports/marketing-analysis/marketing-selling-price')
          && priorRoundPages.includes('analysis/team-reports/marketing-analysis/marketing-awareness')
          && priorRoundPages.includes('analysis/team-reports/operational-analysis/operational-analysis-unit-costs')
          && priorRoundPages.includes('analysis/team-reports/operational-analysis/operational-analysis-unit-costs-breakdown')
          && priorRoundPages.includes('analysis/team-reports/operational-analysis/operational-analysis-inventory-management')
          && priorRoundPages.includes('analysis/team-reports/financing-analysis/financing-analysis-capital-structure')
          && priorRoundPages.includes('analysis/team-reports/financing-analysis/financing-analysis-valuation')
          && priorRoundPages.includes('analysis/team-reports/financing-analysis/financing-analysis-shares')
        );
        const isTriviaDone = pages.includes('round-trivia/trivia/done');

        const userGoals = goalsTargets.results
          .find(i => (
            Number(i.course) === courseId
            && Number(i.round) === roundId
            && Number(i.team) === teamId
            && Number(i.user) === userId
          ));
        const isGoalsSubmitted = !!userGoals;

        const user = Auth.getUser();
        const userRole = roleToUrl(user.role);

        // Per-role "Submitted" checkbox state, derived from team-status.
        // Each role is considered submitted when:
        //   1. A successful submit_* has happened this round
        //      (submission_data.<role>.date !== 'N/A')
        //   2. The user hasn't touched any of that role's decision
        //      endpoints since then (unaccepted_decisions counter is 0)
        // This replaces a journal-history scan that walked every entry
        // looking for the latest submit_* and any newer same-role edits.
        const isSubmittedAndAccepted = (entry) =>
          !!entry && entry.date !== 'N/A' && Number(entry.unaccepted) === 0;
        const pdSubmitted = isSubmittedAndAccepted(statusData.submission_data.pd);
        const pmSubmitted = isSubmittedAndAccepted(statusData.submission_data.pm);
        const opSubmitted = isSubmittedAndAccepted(statusData.submission_data.op);
        const fnSubmitted = isSubmittedAndAccepted(statusData.submission_data.fn);

        this.setState({
          loading: false,
          isBusinessCaseVisited,
          isCustomerAnalysisVisited,
          isPriorRoundVisited,
          isGoalsSubmitted,
          isTriviaDone,
          userRole,
          pdSubmitted,
          pmSubmitted,
          opSubmitted,
          fnSubmitted,
          triviaCourseAvailable
        });
      })
      .catch(err => {
        console.log(err);
      });
  }

  render() {
    const { currentRound } = this.props;
    const {
      loading,
      isBusinessCaseVisited,
      isCustomerAnalysisVisited,
      isPriorRoundVisited,
      isGoalsSubmitted,
      isTriviaDone,
      pdSubmitted,
      pmSubmitted,
      opSubmitted,
      fnSubmitted,
      triviaCourseAvailable
    } = this.state;

    const showMarketResearch = (
      !isBusinessCaseVisited
      || !isCustomerAnalysisVisited
      || !isPriorRoundVisited
    );
    const showGoalsAndTargets = (
      !showMarketResearch
      && !isGoalsSubmitted
    );
    const showTrivia = (
      !showMarketResearch
      && !showGoalsAndTargets
      && !isTriviaDone
    );
    const showSubmitDecisions = (
      !showMarketResearch
      && !showGoalsAndTargets
      && !showTrivia
    );

    const showPriorRound = false;

    return loading ? (
      <Wrapper>
        <Loader type="ball-scale-ripple" active />
      </Wrapper>
    ) : (
      <Wrapper>
        <Container>
          <Text1>Next Steps</Text1>
          <Text2>Complete Round Challenges</Text2>
          {showMarketResearch && (
            <BigGoal>
              <Image>
                <img src={Image1} alt="" />
              </Image>
              <BigGoalTitle>
                <BigGoalTitleNum>1</BigGoalTitleNum>
                <div><a href={`/analysis/bcase/executive-summary?round=${currentRound}`}>Research</a></div>
              </BigGoalTitle>
              <BigGoalDescription>
                Understand the opportunity to help your team
                make informed decisions.
              </BigGoalDescription>
              <CheckboxesRow>
                <Checkbox>Viewed</Checkbox>
                <Checkbox>
                  <img src={isBusinessCaseVisited ? SmallCheckboxActive : SmallCheckbox} alt="small checkbox" />
                  <div><a href={`/analysis/bcase/executive-summary?round=${currentRound}`}>Business Case</a></div>
                </Checkbox>
                <Checkbox>
                  <img src={isCustomerAnalysisVisited ? SmallCheckboxActive : SmallCheckbox} alt="small checkbox" />
                  <div><a href={`/ceo/analysis/market?round=${currentRound}`}>Customer Analysis</a></div>
                </Checkbox>
                {currentRound > 1 && (
                  <Checkbox>
                    <img src={isPriorRoundVisited ? SmallCheckboxActive : SmallCheckbox} alt="small checkbox" />
                    <div><a href={`/analysis/team-reports?round=${currentRound}`}>Prior Round Report</a></div>
                  </Checkbox>
                )}
              </CheckboxesRow>
            </BigGoal>
          )}
          {showMarketResearch && (
            <SmallGoals>
              {
                currentRound > 1 &&
                <SmallGoal>
                  <img src={isGoalsSubmitted ? SmallCheckboxActive : SmallCheckbox} alt="small checkbox" />
                  <SmallGoalTitle>
                    <SmallGoalTitleNum>2</SmallGoalTitleNum>
                    <div><a href={`/analysis/team-reports?round=${currentRound}`}>Read Prior Round Report</a></div>
                  </SmallGoalTitle>
                  <SmallGoalDescription>
                    Analyze and improve your decisions with concrete team reports.
                  </SmallGoalDescription>
                </SmallGoal>
              }
              <SmallGoal>
                <SmallGoalTitle>
                  <SmallGoalTitleNum>{currentRound > 1 ? 3 : 2}</SmallGoalTitleNum>
                  <div><a href={`/goals-and-targets?round=${currentRound}`}>View Goals &amp; Targets</a></div>
                </SmallGoalTitle>
                <SmallGoalDescription>
                  View specific, attainable goals that drive
                  your round decisions.
                </SmallGoalDescription>
              </SmallGoal>
              {
                triviaCourseAvailable !== 0 &&
                <SmallGoal>
                  <img src={isTriviaDone ? SmallCheckboxActive : SmallCheckbox} alt="small checkbox" />
                  <SmallGoalTitle>
                    <SmallGoalTitleNum>{currentRound > 1 ? 4 : 3}</SmallGoalTitleNum>
                    <div><a href={`/round-trivia?round=${currentRound}`}>Take the Trivia</a></div>
                  </SmallGoalTitle>
                  <SmallGoalDescription>
                    Assess how prepared you are for this round.
                  </SmallGoalDescription>
                </SmallGoal>
              }
              <SmallGoal>
                <SmallGoalTitle>
                  <SmallGoalTitleNum>{currentRound > 1 ? (4 + triviaCourseAvailable) : (3 + triviaCourseAvailable)}</SmallGoalTitleNum>
                  <div><a href={`/decisions/ceo?round=${currentRound}`}>Make &amp; Submit Decisions</a></div>
                </SmallGoalTitle>
                <SmallGoalDescription>
                  Reach out and collaborate with your teammates
                  to make and submit decisions.
                </SmallGoalDescription>
              </SmallGoal>
            </SmallGoals>
          )}

          {showPriorRound && (
            <BigGoal>
              <Image>
                <img src={Image5} alt="" />
              </Image>
              <BigGoalTitle>
                <BigGoalTitleNum>2</BigGoalTitleNum>
                <div><a href={`/analysis/team-reports?round=${currentRound}`}>Read Prior Round Report</a></div>
              </BigGoalTitle>
              <BigGoalDescription>
                Analyze and improve your decisions with concrete team reports.
              </BigGoalDescription>
              <CheckboxesRow>
                <Checkbox>Submited</Checkbox>
                <Checkbox>
                  <img src={SmallCheckbox} alt="small checkbox" />
                  <div>Decisions (5)</div>
                </Checkbox>
              </CheckboxesRow>
            </BigGoal>
          )}
          {showPriorRound && (
            <SmallGoals>
              <SmallGoal>
                <SmallGoalTitle>
                  <SmallGoalTitleNum>3</SmallGoalTitleNum>
                  <div><a href={`/goals-and-targets?round=${currentRound}`}>View Goals &amp; Targets</a></div>
                </SmallGoalTitle>
                <SmallGoalDescription>
                  View specific, attainable goals that drive
                  your round decisions.
                </SmallGoalDescription>
              </SmallGoal>
              {
                triviaCourseAvailable !== 0 &&
                <SmallGoal>
                  <img src={SmallCheckboxActive} alt="small checkbox" />
                  <SmallGoalTitle>
                    <SmallGoalTitleNum>4</SmallGoalTitleNum>
                    <div><a href={`/round-trivia?round=${currentRound}`}>Take a Trivia</a></div>
                  </SmallGoalTitle>
                  <SmallGoalDescription>
                    Are you prepared for making new decisions?
                    Take a trivia to assess.
                  </SmallGoalDescription>
                </SmallGoal>
              }
              <SmallGoal>
                <SmallGoalTitle>
                  <SmallGoalTitleNum>{4 + triviaCourseAvailable}</SmallGoalTitleNum>
                  <div><a href={`/decisions/ceo?round=${currentRound}`}>Make &amp; Submit Decisions</a></div>
                </SmallGoalTitle>
                <SmallGoalDescription>
                  Reach out and collaborate with your teammates
                  to make and submit decisions.
                </SmallGoalDescription>
              </SmallGoal>
              <SmallGoal isGreyed={true}>
                <img src={SmallCheckboxActive} alt="small checkbox" />
                <SmallGoalTitle>
                  <SmallGoalTitleNum>1</SmallGoalTitleNum>
                  <div><a href={`/analysis/bcase/executive-summary?round=${currentRound}`}>Research</a></div>
                </SmallGoalTitle>
                <SmallGoalDescription>
                  Understand the image censor market opportunity and the customers.
                </SmallGoalDescription>
              </SmallGoal>
            </SmallGoals>
          )}

          {showGoalsAndTargets && (
            <BigGoal>
              <Image>
                <img src={Image2} alt="" />
              </Image>
              <BigGoalTitle>
                <BigGoalTitleNum>{currentRound > 1 ? 3 : 2}</BigGoalTitleNum>
                <div><a href={`/goals-and-targets?round=${currentRound}`}>View Goals &amp; Targets</a></div>
              </BigGoalTitle>
              <BigGoalDescription>
                View specific, attainable goals that drive your round decisions.
              </BigGoalDescription>
              <CheckboxesRow>
                {/* <Checkbox>Submitted</Checkbox>
                <Checkbox>
                  <img src={isGoalsSubmitted ? SmallCheckboxActive : SmallCheckbox} alt="small checkbox" />
                  <div><a href={`/goals-and-targets?round=${currentRound}`}>Goals &amp; Targets</a></div>
                </Checkbox> */}
              </CheckboxesRow>
            </BigGoal>
          )}
          {showGoalsAndTargets && (
            <SmallGoals>
              {
                triviaCourseAvailable !== 0 &&
                <SmallGoal>
                  <img src={isTriviaDone ? SmallCheckboxActive : SmallCheckbox} alt="small checkbox" />
                  <SmallGoalTitle>
                    <SmallGoalTitleNum>{currentRound > 1 ? 4 : 3}</SmallGoalTitleNum>
                    <div><a href={`/round-trivia?round=${currentRound}`}>Take the Trivia</a></div>
                  </SmallGoalTitle>
                  <SmallGoalDescription>
                    Assess how prepared you are for this round.
                  </SmallGoalDescription>
                </SmallGoal>
              }
              <SmallGoal>
                <SmallGoalTitle>
                  <SmallGoalTitleNum>{currentRound > 1 ? (4 + triviaCourseAvailable) : (3 + triviaCourseAvailable)}</SmallGoalTitleNum>
                  <div><a href={`/decisions/ceo?round=${currentRound}`}>Make &amp; Submit Decisions</a></div>
                </SmallGoalTitle>
                <SmallGoalDescription>
                  Reach out and collaborate with your teammates
                  to make and submit decisions.
                </SmallGoalDescription>
              </SmallGoal>
              <SmallGoal isGreyed={true}>
                <img src={SmallCheckboxActive} alt="small checkbox" />
                <SmallGoalTitle>
                  <SmallGoalTitleNum>1</SmallGoalTitleNum>
                  <div><a href={`/analysis/bcase/executive-summary?round=${currentRound}`}>Research</a></div>
                </SmallGoalTitle>
                <SmallGoalDescription>
                  Understand the image censor market opportunity and the customers.
                </SmallGoalDescription>
              </SmallGoal>
              {
                currentRound > 1 &&
                <SmallGoal isGreyed={true}>
                  <img src={isGoalsSubmitted ? SmallCheckboxActive : SmallCheckbox} alt="small checkbox" />
                  <SmallGoalTitle>
                    <SmallGoalTitleNum>2</SmallGoalTitleNum>
                    <div><a href={`/analysis/team-reports?round=${currentRound}`}>Read Prior Round Report</a></div>
                  </SmallGoalTitle>
                  <SmallGoalDescription>
                    Analyze and improve your decisions with concrete team reports.
                  </SmallGoalDescription>
                </SmallGoal>
              }
            </SmallGoals>
          )}
          {(showTrivia && triviaCourseAvailable !== 0) && (
            <BigGoal>
              <Image>
                <img src={Image3} alt="" />
              </Image>
              <BigGoalTitle>
                <BigGoalTitleNum>{currentRound > 1 ? 4 : 3}</BigGoalTitleNum>
                <div>Take a Trivia</div>
              </BigGoalTitle>
              <BigGoalDescription>
                Are you prepared for making new decisions? Assess
                with a few questions.
              </BigGoalDescription>
              <CheckboxesRow>
                <Checkbox>Completed</Checkbox>
                <Checkbox>
                  <img src={isTriviaDone ? SmallCheckboxActive : SmallCheckbox} alt="small checkbox" />
                  <div><a href={`/round-trivia?round=${currentRound}`}>Trivia</a></div>
                </Checkbox>
              </CheckboxesRow>
            </BigGoal>
          )}
          {showTrivia && (
            <SmallGoals>
              <SmallGoal>
                <SmallGoalTitle>
                  <SmallGoalTitleNum>{currentRound > 1 ? (4 + triviaCourseAvailable) : (3 + triviaCourseAvailable)}</SmallGoalTitleNum>
                  <div><a href={`/decisions/ceo?round=${currentRound}`}>Make &amp; Submit Decisions</a></div>
                </SmallGoalTitle>
                <SmallGoalDescription>
                  Reach out and collaborate with your teammates
                  to make and submit decisions.
                </SmallGoalDescription>
              </SmallGoal>
              <SmallGoal isGreyed={true}>
                <img src={SmallCheckboxActive} alt="small checkbox" />
                <SmallGoalTitle>
                  <SmallGoalTitleNum>1</SmallGoalTitleNum>
                  <div><a href={`/analysis/bcase/executive-summary?round=${currentRound}`}>Research</a></div>
                </SmallGoalTitle>
                <SmallGoalDescription>
                  Understand the image censor market opportunity and the customers.
                </SmallGoalDescription>
              </SmallGoal>
              {
                currentRound > 1 &&
                <SmallGoal isGreyed={true}>
                  <img src={isGoalsSubmitted ? SmallCheckboxActive : SmallCheckbox} alt="small checkbox" />
                  <SmallGoalTitle>
                    <SmallGoalTitleNum>2</SmallGoalTitleNum>
                    <div><a href={`/analysis/team-reports?round=${currentRound}`}>Read Prior Round Report</a></div>
                  </SmallGoalTitle>
                  <SmallGoalDescription>
                    Analyze and improve your decisions with concrete team reports.
                  </SmallGoalDescription>
                </SmallGoal>
              }
              <SmallGoal isGreyed={true}>
                <SmallGoalTitle>
                  <SmallGoalTitleNum>{currentRound > 1 ? 3 : 2}</SmallGoalTitleNum>
                  <div><a href={`/goals-and-targets?round=${currentRound}`}>View Goals &amp; Targets</a></div>
                </SmallGoalTitle>
                <SmallGoalDescription>
                  View specific, attainable goals that drive
                  your round decisions.
                </SmallGoalDescription>
              </SmallGoal>
            </SmallGoals>
          )}
          {showSubmitDecisions && (
            <BigGoal>
              <Image>
                <img src={Image4} alt="" />
              </Image>
              <BigGoalTitle>
                <BigGoalTitleNum>{currentRound > 1 ? (4 + triviaCourseAvailable) : (3 + triviaCourseAvailable)}</BigGoalTitleNum>
                <div><a href={`/decisions/ceo?round=${currentRound}`}>Make &amp; Submit Decisions</a></div>
              </BigGoalTitle>
              <BigGoalDescription>
                Gather information, evaluate possible resolutions
                and make team choices.
              </BigGoalDescription>
              <CheckboxesRow>
                <Checkbox>Submitted</Checkbox>
                <Checkbox>
                  <img src={pdSubmitted ? SmallCheckboxActive : SmallCheckbox} alt="small checkbox" />
                  <div><a href={`/decisions/product-development?round=${currentRound}`}>Product</a></div>
                </Checkbox>
                <Checkbox>
                  <img src={pmSubmitted ? SmallCheckboxActive : SmallCheckbox} alt="small checkbox" />
                  <div><a href={`/decisions/product-marketing?round=${currentRound}`}>Marketing</a></div>
                </Checkbox>
                <Checkbox>
                  <img src={opSubmitted ? SmallCheckboxActive : SmallCheckbox} alt="small checkbox" />
                  <div><a href={`/decisions/operations?round=${currentRound}`}>Operations</a></div>
                </Checkbox>
                <Checkbox>
                  <img src={fnSubmitted ? SmallCheckboxActive : SmallCheckbox} alt="small checkbox" />
                  <div><a href={`/decisions/finance?round=${currentRound}`}>Finance</a></div>
                </Checkbox>
              </CheckboxesRow>
            </BigGoal>
          )}
          {showSubmitDecisions && (
            <SmallGoals>
              <SmallGoal isGreyed={true}>
                <img src={SmallCheckboxActive} alt="small checkbox" />
                <SmallGoalTitle>
                  <SmallGoalTitleNum>1</SmallGoalTitleNum>
                  <div><a href={`/analysis/bcase/executive-summary?round=${currentRound}`}>Research</a></div>
                </SmallGoalTitle>
                <SmallGoalDescription>
                  Understand the image censor market opportunity and the customers.
                </SmallGoalDescription>
              </SmallGoal>
              {
                currentRound > 1 &&
                <SmallGoal isGreyed={true}>
                  <img src={isGoalsSubmitted ? SmallCheckboxActive : SmallCheckbox} alt="small checkbox" />
                  <SmallGoalTitle>
                    <SmallGoalTitleNum>2</SmallGoalTitleNum>
                    <div><a href={`/analysis/team-reports?round=${currentRound}`}>Read Prior Round Report</a></div>
                  </SmallGoalTitle>
                  <SmallGoalDescription>
                    Analyze and improve your decisions with concrete team reports.
                  </SmallGoalDescription>
                </SmallGoal>
              }
              <SmallGoal isGreyed={true}>
                <SmallGoalTitle>
                  <SmallGoalTitleNum>{currentRound > 1 ? 3 : 2}</SmallGoalTitleNum>
                  <div><a href={`/goals-and-targets?round=${currentRound}`}>View Goals &amp; Targets</a></div>
                </SmallGoalTitle>
                <SmallGoalDescription>
                  View specific, attainable goals that drive
                  your round decisions.
                </SmallGoalDescription>
              </SmallGoal>
              {
                triviaCourseAvailable !== 0 &&
                <SmallGoal isGreyed={true}>
                  <img src={SmallCheckboxActive} alt="small checkbox" />
                  <SmallGoalTitle>
                    <SmallGoalTitleNum>{currentRound > 1 ? 4 : 3}</SmallGoalTitleNum>
                    <div>Take a Trivia</div>
                  </SmallGoalTitle>
                  <SmallGoalDescription>
                    Are you prepared for making new decisions?
                    Take a trivia to assess.
                  </SmallGoalDescription>
                </SmallGoal>
              }
            </SmallGoals>
          )}
        </Container>
      </Wrapper>
    );
  }

}

export default NextStepsPage;



// WEBPACK FOOTER //
// ./src/components/onboarding/NextSteps.js